import { Component, Input } from '@angular/core';
import { SbNameWrapperComponent } from '../sb-name-wrapper/sb-name-wrapper.component';
import { PublicMediumDTO, ThumbnailableFileLink, ThumbnailSize } from '../../../services/api/api';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: 'sb-comp-image-name-wrapper',
  templateUrl: './sb-image-name-wrapper.component.html',
  styleUrls: ['./sb-image-name-wrapper.component.scss'],
  standalone: false,
})
export class SbImageNameWrapperComponent extends SbNameWrapperComponent {
  @Input() classes: string = '';
  /* Inputs for MediumDTO */
  @Input() customWidth: string;
  @Input() customHeight: string;
  @Input() tooltipInterval: number;
  @Input() hoverPreview: boolean = true;
  @Input() hidePlaceholder: boolean = false;
  @Input() showFullOnClick: boolean;
  @Input() thumbnailSize: string = ThumbnailSize.M;
  @Input() still: boolean = true;
  @Input() background: boolean;
  @Input() loading: boolean = false;
  @Input() hideArrows: boolean = false;
  @Input() hideIndicators: boolean = false;

  @Input({
    transform: (value: ThumbnailableFileLink | string | undefined, context: any = this): string => {
      if (value instanceof ThumbnailableFileLink) {
        return context.util.appendQueryParamToUrl(value as unknown as string, '+ ?thumbnail=' + context.thumbnailSize) ?? '';
      }
      return value ?? '';
    },
  })
  image: string;

  @Input({
    alias: 'medium',
    transform: (med: PublicMediumDTO | PublicMediumDTO[]): PublicMediumDTO[] => {
      if (!med) {
        return undefined;
      }
      if (!Array.isArray(med)) {
        med = [med];
      }
      return med ?? undefined;
    },
  })
  previews: PublicMediumDTO[];

  constructor(public util: UtilService) {
    super();
  }

  hasInput(name: string): boolean {
    if (name === 'image' && this.image != null) {
      return true;
    }
    return name === 'medium' && this.previews?.length > 0;
  }

  shouldShowInput(name: string): boolean {
    if (!this.hasInput(name) && this.hidePlaceholder) {
      return false;
    }
    if (name === 'image') {
      return this.hasInput('image') || (!this.hasInput('medium') && this.image !== '');
    }
    if (name === 'medium') {
      return this.hasInput('medium') || (!this.hasInput('image') && this.image === '');
    }
  }
}
